import styled from 'styled-components';

import { Divider as DividerComponent } from '@xingternal/divider';
import { Flag as FlagComponent } from '@xingternal/flag';
import { Menu as MenuComponent } from '@xingternal/menu';
import { spaceL, spaceM, spaceS } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

export const Menu = styled(MenuComponent)`
  max-width: 350px;
  max-height: 42vh;
  overflow-y: auto;
`;

export const BottomSheetTitle = styled(Meta)`
  margin: ${spaceS};
  margin-bottom: ${spaceL};
  text-align: center;
`;

export const Divider = styled(DividerComponent)`
  margin: 0 -${spaceS} ${spaceM};
`;

export const Flag = styled(FlagComponent)`
  margin-right: ${spaceS};
`;
